<template>
  <header class="site-header">
    <div class="site-container header-inner">
      <div class="brand-area">
        <router-link to="/home" class="brand" aria-label="源盛国际首页">
          <img src="@/assets/imgs/ysgj_001@2x.png" alt="源盛国际" class="brand-img">
        </router-link>
        <div class="brand-right">
          <div class="header-phone">{{ phone }}</div>
          <div class="brand-slogan">{{ slogan }}</div>
        </div>
      </div>

      <nav class="header-nav">
        <div
          v-for="item in navItems"
          :key="item.key"
          class="nav-item"
          :class="{ active: activeNav === item.key, 'has-dropdown': item.children }"
          @mouseenter="item.open = true"
          @mouseleave="item.open = false"
        >
          <router-link :to="item.to || item.path">{{ item.label }}</router-link>
          <transition name="fade">
            <div v-show="item.open && item.children" :class="['dropdown', item.children && item.children.length > 4 ? 'dropdown-wide' : '']">
              <router-link
                v-for="sub in item.children"
                :key="sub.key"
                :to="sub.to || sub.path"
              >{{ sub.label }}</router-link>
            </div>
          </transition>
        </div>
      </nav>

      <div class="header-search">
        <input
          v-model="keyword"
          type="text"
          placeholder="请输入关键字搜索"
          @keyup.enter="onSearch"
        >
        <button type="button" @click="onSearch">
          <img src="@/assets/imgs/ysgj_002@2x.png" alt="搜索">
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { buildProjectDetailPath } from '@/data/siteData'
import { getProjectList, getSettingsData } from '@/api'

export default {
  name: 'SiteHeader',
  data() {
    return {
      keyword: '',
      phone: '021-62897767',
      slogan: '专业 / 诚信 / 稳健',
      navItems: [
        { key: 'home', label: '首页', to: '/home', open: false },
        {
          key: 'visa',
          label: '签证移民',
          to: '/visa',
          open: false,
          children: [],
        },
        { key: 'cases', label: '成功案例', to: { path: '/news', query: { tab: 'cases' } }, open: false },
        {
          key: 'about',
          label: '关于源盛',
          to: '/about',
          open: false,
          children: [
            { key: 'about-intro', label: '公司介绍', to: '/about' },
            { key: 'about-honor', label: '资质荣誉', to: { path: '/about', query: { tab: 'honor' } } },
          ],
        },
        { key: 'contact', label: '联系我们', to: '/contact', open: false },
      ],
    }
  },
  created() {
    this.fetchHeaderData()
  },
  computed: {
    activeNav() {
      const routeMap = {
        home: 'home',
        visa: 'visa',
        'project-detail': 'visa',
        news: 'cases',
        'news-detail': 'cases',
        search: 'cases',
        about: 'about',
        contact: 'contact',
      }
      return routeMap[this.$route.name] || ''
    },
  },
  watch: {
    '$route.query.keyword': {
      immediate: true,
      handler(val) {
        if (this.$route.name === 'search') {
          this.keyword = val || ''
        }
      },
    },
  },
  methods: {
    async fetchHeaderData() {
      try {
        const [settings, projects] = await Promise.all([
          getSettingsData(),
          getProjectList(),
        ])
        this.phone = settings?.phone || this.phone
        this.slogan = settings?.slogan || this.slogan
        const visaItem = this.navItems.find((item) => item.key === 'visa')
        if (visaItem) {
          visaItem.children = Array.isArray(projects?.list)
            ? projects.list.map((project) => ({
              key: `project-${project.id}`,
              label: project.name,
              to: buildProjectDetailPath(project.id),
            }))
            : []
        }
      } catch (error) {
        const visaItem = this.navItems.find((item) => item.key === 'visa')
        if (visaItem) {
          visaItem.children = []
        }
      }
    },
    onSearch() {
      const value = this.keyword.trim()
      if (!value) {
        return
      }
      this.$router.push({
        path: '/search',
        query: { keyword: value },
      })
    },
  },
}
</script>

<style scoped>
.site-header {
  position: relative;
  width: 100%;
  min-width: 1240px;
  z-index: 200;
  height: 68px;
  border-bottom: 1px solid var(--site-border);
  background: #fff;
}

.header-inner {
  min-width: 1200px;
  height: 100%;
  display: grid;
  grid-template-columns: auto 1fr 190px;
  align-items: center;
  gap: 10px;
}

.brand-area {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-img {
  height: 56px;
  width: auto;
  display: block;
}

.brand-right {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.brand-slogan {
  font-size: 16px;
  line-height: 1;
  color: #304763;
  letter-spacing: 0;
  font-weight: 700;
}

.header-phone {
  color: #e74c3c;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1;
  white-space: nowrap;
}

.header-nav {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
  min-width: 0;
  white-space: nowrap;
}

.nav-item {
  position: relative;
  flex: 0 0 auto;
}

.nav-item > a {
  position: relative;
  display: flex;
  align-items: center;
  height: 68px;
  color: #4a5463;
  font-size: 14px;
  transition: color 0.2s ease;
  white-space: nowrap;
  font-weight: 500;
}

.nav-item:hover > a,
.nav-item.active > a {
  color: var(--site-blue);
}

.nav-item.active > a {
  font-weight: 700;
}

.nav-item.active > a::after {
  content: '';
  position: absolute;
  left: 50%;
  width: 56px;
  transform: translateX(-50%);
  bottom: 6px;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: var(--site-blue);
}

.dropdown {
  position: absolute;
  top: 68px;
  left: 0;
  background: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 12px 28px rgba(0,0,0,0.1);
  padding: 10px 16px;
  z-index: 300;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dropdown-wide {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  grid-template-rows: repeat(6, auto);
  grid-auto-flow: column;
  gap: 4px 28px;
  padding: 10px 20px;
}

.dropdown a {
  padding: 8px 4px;
  font-size: 13px;
  color: #4a5463;
  white-space: nowrap;
  transition: all 0.2s;
  border-radius: 4px;
}

.dropdown a:hover {
  background: #f0f5fb;
  color: var(--site-blue);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.header-search {
  height: 36px;
  border: 1px solid #dfe4eb;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 1fr 34px;
  overflow: hidden;
  justify-self: end;
  width: 200px;
  background: #fff;
}

.header-search input {
  border: none;
  outline: none;
  font-size: 12px;
  color: #5f6774;
  padding: 0 12px;
  background: transparent;
}

.header-search input::placeholder {
  color: #b3bac4;
}

.header-search button {
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.header-search button img {
  width: 20px;
  height: 20px;
  opacity: 0.55;
}

.header-search button:hover img {
  opacity: 0.85;
}
</style>
